<template>
  <GenericReport
    ref="report"
    class="maxh-1bar clean-list"
    hide-header
    orientation="horizontal"
    :reportSpec="reportSpec"
    :adapterSpec="adapterSpec"
    :fetcher="fetchData"
    @rowClicked="selectRow"
  >
    <template v-slot:topbar-actions>
      <v-spacer />
      <v-btn color="primary" @click="newVehicle">
        Novo Veículo...
      </v-btn>
    </template>
  </GenericReport>
</template>

<script>
import { Vehicle } from '@/models'
import GenericReport from 'oderon-vue/cpts/generic-report/GenericReport.vue'
import utils from 'oderon-commons/src/utils.js'
import { fullSpec2 as adapterSpec } from './org-vehicle-columns.js'

export default {
  expose: ['reload'],
  tabTitle: 'Veículos',
  components: {
    GenericReport
  },
  props: { value: { required: true } },
  data() {
    return {
      adapterSpec,
      reportSpec: {
        title: 'Veículos',
        filters: [
          {
            type: 'Text',
            prefix: 'keywords',
            icon: 'mdi-magnify',
            size: 'sm',
            debounceMs: 250
          },
          {
            type: 'Switch',
            prefix: 'hideNoClient',
            label: 'Ocultar veículos sem módulo',
            defVal: true
          }
        ]
      },
      selectedIds: []
    }
  },
  computed: {
    menuOpts() {
      return [
        {
          text: 'Remover...',
          icon: 'mdi-delete',
          disabled: this.selectedIds.length < 1,
          onClick: () => this.confirmDelete()
        }
      ]
    }
  },
  watch: {
    value() {
      this.reload()
    }
  },
  methods: {
    reload() {
      this.$refs.report.reload()
    },

    async fetchData(ps) {
      let res = await Vehicle.findAll({
        orgIds: this.value.id,
        andCount: true,
        order: 'code asc',
        ...ps
      })
      return res
    },

    async newVehicle() {
      let label = 'Digite a placa do novo veículo:'
      let code = await this.$prompt({ label })

      if (!utils.isEmpty(code)) {
        this.$rootLoading(async () => {
          code = code.trim().toUpperCase()
          let created = await Vehicle.save({ code, orgId: this.value.id })
          this.$router.push(`/vehicles/${created.id}`)
          this.$snack('Salvo com sucesso')
        })
      }
    },

    async selectRow({ row, isMiddle }) {
      row = await Vehicle.findById(row.id)
      let url = `/vehicles/${row.id}`
      if (row.clientId != null) url = `/clients/${row.clientId}`

      if (isMiddle) {
        window.open(`/#${url}`, '_blank')
      } else {
        this.$router.push(url)
      }
    }
  }
}
</script>

<style></style>
